var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import styles from './FormInput.styl';
import TextField from '../TextField/TextField';
let FormInput = class FormInput extends React.Component {
    render() {
        const { autoComplete, shouldTruncate, className, errorPosition, showPlaceholder, inputPlaceholder, placeholder, field, type, t, min, step, max, onKeyPress, id, errorClassName, inputClassName } = this.props;
        const wrapperClassName = classnames(className, styles.field, { [styles.errorTruncated]: shouldTruncate });
        const errorClassNames = classnames(styles.errorText, errorClassName, styles[`error${errorPosition}`]);
        const hasError = field.hasError;
        const error = field.error;
        const showLabel = (field.touched && showPlaceholder) ? `${styles.placeholderAnimate} ${styles.placeholderAnimateShow}` : `${styles.placeholderAnimate}`;
        const props = {
            ...field.bind(),
            autoComplete,
            min, step, max, id,
            onKeyPress,
            placeholder: inputPlaceholder ? inputPlaceholder : t(field.placeholder)
        };
        return (React.createElement("div", { className: classnames(wrapperClassName) },
            React.createElement("span", { className: showLabel }, placeholder),
            React.createElement(TextField, { error: hasError && error, ...props, inputClassName: inputClassName, type: type || field.type }),
            hasError && error ? (React.createElement("span", { className: errorClassNames }, error)) : false));
    }
};
Object.defineProperty(FormInput, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        className: '',
        errorPosition: 'BottomLeft',
        showPlaceholder: false,
        shouldTruncate: true,
        t: () => { }
    }
});
FormInput = __decorate([
    observer
], FormInput);
export default FormInput;
